import { Controller } from "@hotwired/stimulus"

// Collapsible sections that remember, per browser, what each person leaves open -
// Dragana keeps the documents open, Ivor keeps everything shut, nobody re-clicks daily.
export default class extends Controller {
  static targets = ["fold"]

  connect() {
    let saved = {}
    try { saved = JSON.parse(localStorage.getItem("ordinacija-folds") || "{}") } catch { /* private mode etc. */ }
    this.foldTargets.forEach(fold => { if (fold.id in saved) fold.open = saved[fold.id] })
    // "toggle" does not bubble; a capturing listener on the wrapper still sees it.
    this.element.addEventListener("toggle", () => this.save(), true)
  }

  save() {
    const state = {}
    this.foldTargets.forEach(fold => { state[fold.id] = fold.open })
    try { localStorage.setItem("ordinacija-folds", JSON.stringify(state)) } catch { /* ignore */ }
  }
}
